import Vue from 'vue'
import VueRouter from 'vue-router'
import AppHome from '@/components/AppHome'
import AppLogin from '@/components/AppLogin'
import AppRegister from '@/components/AppRegister'
import AppVideo from '@/components/AppVideo'
import AppVideo1 from '@/components/AppVideo1'
import AppVideo2 from '@/components/AppVideo2'
import AppVideo3 from '@/components/AppVideo3'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'AppHome',
    component: AppHome
  },
  {
    path: '/login',
    name: 'AppLogin',
    component: AppLogin
  },
  {
    path: '/register',
    name: 'AppRegister',
    component: AppRegister
  },
  {
    path: '/video',
    name: 'AppVideo',
    component: AppVideo
  },
  {
    path: '/video1',
    name: 'AppVideo1',
    component: AppVideo1
  },
  {
    path: '/video2',
    name: 'AppVideo2',
    component: AppVideo2
  },
  {
    path: '/video3',
    name: 'AppVideo3',
    component: AppVideo3
  },
]

const router = new VueRouter({
  routes
})

export default router
